import { render, staticRenderFns } from "./demandFour.vue?vue&type=template&id=735dd28e&scoped=true"
import script from "./demandFour.vue?vue&type=script&lang=js"
export * from "./demandFour.vue?vue&type=script&lang=js"
import style0 from "./demandFour.vue?vue&type=style&index=0&id=735dd28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735dd28e",
  null
  
)

export default component.exports